import type { FaireProductEntity } from "../../entity_types/product";

export const p_7atqcnc334: FaireProductEntity = {
  token: "p_7atqcnc334",
  type: "product",
  name: "Stripe Sleeveless Maxi Dress",
  brandToken: "b_7nt3s643r3",
  brandName: "English Factory",
  imageUrl:
    "https://cdn.faire.com/fastly/7418c44e124f3d6d4873f16996f225f0fb54a73c57cbe0779c866bf34b4f47cb.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/33b03d848781d4974bf0792f8a7312d6ca79f1a71b2e79b825083a31e408ae3c.jpeg",
    "https://cdn.faire.com/fastly/b21b9f2eec33f847dd2cc9756e204f3b1e12d8bf5692ec31355fbd6c75e515d0.jpeg",
    "https://cdn.faire.com/fastly/c2a09bb0bfc3dc72782a62ec0f41c6e444ac6c32cfd0c582703ec41493785dc4.jpeg",
    "https://cdn.faire.com/fastly/ef1b27437941a138c2956cdc5a6f83bbdb0987a7557b3a7459485a77e5885607.jpeg",
    "https://cdn.faire.com/fastly/d6dbb140120006be73abc187672c2775294e6b7d05563fb7014782fccbabbd1a.jpeg",
  ],
  priceDollars: 52,
  description:
    'Make a statement in style with our Stripe Sleeveless Maxi Dress. Featuring bold stripes that never go out of style, this dress is perfect for any occasion. The straight neckline and sleeveless design add a touch of elegance, while the shoulder straps provide the perfect fit. Made with high-quality material, this dress is comfortable and versatile. Dress it up with heels for a night out or keep it casual with sandals for a day at the beach. Stand out from the crowd and rock this must-have dress that combines fashion and comfort. Shop now and embrace the timeless trend of stripes! \n * Striped \n * Straight neckline \n * Sleeveless \n * Shoulder straps \n * Shirring details \n * Back cut out detail with tie \n * Maxi length \n * Lining \n * Hand wash cold \n * Do not bleach \n * Do not tumble dry \n * Iron low \n * Exclusive of Elastic \n * Shell: 97% Cotton 3% Spandex \n * Lining: 100% Cotton \n\n\nSS360D Total length: 51" Bust: 31.5" S NAVY/WHITE: Height 5\'9.5" / Bust 32" / Waist 24" / Hip 35"',
  tags: [],
  msrpDollars: 140,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T06:20:02.130Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
